import { render } from "./ZioEdge.vue?vue&type=template&id=205d6fa2&scoped=true"
import script from "./ZioEdge.vue?vue&type=script&lang=js"
export * from "./ZioEdge.vue?vue&type=script&lang=js"

import "./ZioEdge.vue?vue&type=style&index=0&id=205d6fa2&scoped=true&lang=css"

import exportComponent from "/usr/src/app/ziohome_ver3_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-205d6fa2"]])

export default __exports__